import * as collection from '../../utils/collection';
import { Post } from './post';

export enum PostsLoadingState { Loading, Loaded, Error }

export interface PostsState {
  status: PostsLoadingState;
  posts: collection.Collection<Post>;
}
